const DEFAULT_CHECK_INTERVAL = 60 * 1000;
const BUILD_VERSION_URL = '/version.json';

export function useBuildVersionCheck(options = {}) {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  const currentBuildId = process.env.VUE_APP_BUILD_ID;

  if (!currentBuildId || typeof window === 'undefined') {
    return;
  }

  const checkInterval = options.checkInterval || DEFAULT_CHECK_INTERVAL;
  let isChecking = false;

  const reloadIfVersionChanged = async () => {
    if (isChecking) {
      return;
    }

    isChecking = true;

    try {
      const response = await fetch(`${BUILD_VERSION_URL}?t=${Date.now()}`, {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache',
        },
      });

      if (!response.ok) {
        return;
      }

      const version = await response.json();

      if (version.buildId && version.buildId !== currentBuildId) {
        window.location.reload();
      }
    } catch {
      // Version checks must never interrupt normal app usage.
    } finally {
      isChecking = false;
    }
  };

  window.setInterval(reloadIfVersionChanged, checkInterval);
  window.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      reloadIfVersionChanged();
    }
  });
}
